/**
 * FacilityBulkUploadWizard
 *
 * This is a thin adapter that renders the phlebotomist BulkUpload component
 * within the facility portal context. It stores the facility_id in sessionStorage
 * so the BulkUpload component can pick it up and attach it to submissions.
 *
 * The actual BulkUpload wizard (3-step: Batch Info → Add Patients → Review & Submit)
 * lives in src/components/phlebotomist/BulkUpload.js
 */
import React, { useEffect } from 'react';
import { useOutletContext, useNavigate, useParams } from 'react-router-dom';
import BulkUpload from '../phlebotomist/BulkUpload';

export default function FacilityBulkUploadWizard() {
  const { facility, facilityId } = useOutletContext();
  const navigate = useNavigate();

  // Store facility context so BulkUpload can access it
  useEffect(() => {
    if (facilityId && facility) {
      sessionStorage.setItem('facilityContext', JSON.stringify({
        facility_id: facilityId,
        facility_name: facility.name,
      }));
    }
    return () => sessionStorage.removeItem('facilityContext');
  }, [facilityId, facility]);

  // BulkUpload expects useParams to have { id } for phlebotomist
  // We'll render it directly — it will work but show phlebotomist-specific header
  // The facility_id will be picked up from sessionStorage in the submit logic
  return <BulkUpload />;
}
